'use client';
import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
  textColor?: string;
  dividerColor?: string;
}

export default function FAQAccordion({ items, textColor = '#08294a', dividerColor = '#FBFCFD' }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="w-full max-w-3xl">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const answerId = `faq-answer-${index}`;
        return (
          <div key={index}>
            <div className="w-full" style={{ backgroundColor: dividerColor, height: '1px' }} />
            <div>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                aria-controls={answerId}
                className="flex w-full cursor-pointer items-center gap-4 py-6 text-left transition-colors duration-200 focus:outline-none group text-[rgba(205,209,213,1)] bg-[rgba(236,234,234,0)]"
              >
                <span className="flex-1 text-base font-semibold" style={{ color: textColor, fontFamily: 'Source Sans 3, sans-serif' }}>
                  {item.question}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="transition-transform duration-200"
                  style={{
                    color: textColor,
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                </svg>
              </button>
              <div id={answerId} className="pb-6" hidden={!isOpen}>
                <p className="text-sm leading-relaxed" style={{ color: textColor, fontFamily: 'Source Sans 3, sans-serif' }}>
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
      <div className="w-full" style={{ backgroundColor: dividerColor, height: '1px' }} />
    </div>
  );
}
